<template>
  <svg
    :height="height"
    viewBox="0 0 16 16"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#00173E">
        <path
          d="M10.5 0c.245 0 .45.177.492.41L11 .5V2h2.5c.78 0 1.42.595 1.493 1.356L15 3.5v11c0 .828-.672 1.5-1.5 1.5h-12C.672 16 0 15.328 0 14.5v-11C0 2.672.672 2 1.5 2H4V.5c0-.276.224-.5.5-.5.245 0 .45.177.492.41L5 .5V2h5V.5c0-.276.224-.5.5-.5zM14 6H1v8.5c0 .245.177.45.41.492L1.5 15h12c.276 0 .5-.224.5-.5V6zm-.5-3h-12c-.276 0-.5.224-.5.5V5h13V3.5c0-.245-.177-.45-.41-.492L13.5 3z"
          transform="translate(1)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'CalendarIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
  },
};
</script>

<style lang="scss"></style>
